import styled from '@emotion/styled';
import { Container } from '@mui/material';
import { theme } from '../../lib/index';

export const ImageContainer = styled(Container, {})({
  margin: '20px auto 20px',
  '& img': {
    width: 50,
    height: 'auto',
  },

  [theme.breakpoints.up('laptop')]: {
    margin: '100px auto 20px',
    '& img': {
      width: 150,
      heigth: 'auto',
    },
  },
});
